import { Text } from "../../../../components/common/typography";
import { IconAlertCircle } from "@tabler/icons-react";
export interface ChangesRequestedBannerProps {
    reviewNote?: string | null;
    reviewedAt?: string | null;
}
export function ChangesRequestedBanner({ reviewNote, reviewedAt, }: ChangesRequestedBannerProps) {
    return (<div className="flex gap-3 rounded-lg border border-accentYellowTint bg-accentYellowTint/40 p-4">
      <IconAlertCircle size={20} style={{
            color: "#B45309"
        }}/>
      <div className="flex-1">
        <Text variant="bodySm" className="text-accentError font-semibold">
          Changes requested by admin
        </Text>
        {reviewNote ? (<Text variant="bodySm" className="text-textDefault mt-1 whitespace-pre-wrap">
            {reviewNote}
          </Text>) : (<Text variant="bodySm" className="text-textMuted mt-1">
            No note provided.
          </Text>)}
        {reviewedAt && (<Text variant="bodyXs" className="text-textMuted mt-2">
            {new Date(reviewedAt).toLocaleString()}
          </Text>)}
      </div>
    </div>);
}
